import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  image: Yup.mixed().required("Image is required"),
  advertisement_for: Yup.string()
    .oneOf(["product", "service", "brand"], "Invalid selection")
    .required("Advertisement type is required"),
  product: Yup.mixed().nullable(), // Nullable because it can be null
  duration: Yup.number()
    .positive("Duration must be greater than 0")
    .required("Duration is required"),
  start_date: Yup.date().required("Start date is required"),
  end_date: Yup.date()
    .min(Yup.ref("start_date"), "End date must be after start date")
    .required("End date is required"),
  audience_type: Yup.string().required("Audience type is required"),
  target_audience_age: Yup.number()
    .min(13, "Minimum age must be 13")
    .max(100, "Maximum age must be 100")
    .required("Target audience age is required"),
  location_radius: Yup.number()
    .min(0, "Radius cannot be negative")
    .required("Location radius is required"),
  gender: Yup.string()
    .oneOf(["Male", "Female", "All"], "Invalid gender selection")
    .required("Gender selection is required"),
  advertisement_budget: Yup.number()
    .min(0, "Budget cannot be negative")
    .required("Advertisement budget is required"),
  advertisement_tax: Yup.number()
    .min(0, "Tax cannot be negative")
    .required("Advertisement tax is required"),
  advertise_views: Yup.number()
    .min(0, "Views cannot be negative")
    .required("Advertise views are required"),
  ordered_by_advertise: Yup.number()
    .min(0, "Orders cannot be negative")
    .required("Ordered by advertisement is required"),
  addToCart_count: Yup.number()
    .min(0, "Add to cart count cannot be negative")
    .required("Add to cart count is required"),
  share: Yup.number()
    .min(0, "Share count cannot be negative")
    .required("Share count is required"),
});

export default validationSchema;



